import Vue from 'vue'

// This is used to notify the parent page of the iframe, so that it can handle events
// It is called channel because we were going to use JSChannel at one stage
// And it is still a type of communication channel

// the first param to postMesage should be a stringified JSON object, using the following template
// {"method":"name", "params":[{ "first" : "value"}, {"second" : "value"}]}

const triggerCloseNotification = (managerId) => {
  window.parent.postMessage(JSON.stringify({method: 'close', managerId, params: []}), '*')
}

// error can either be
// - String (didn't find examples)
// - Object with Properties (didn't find examples)
// - JS Error object (which Axios also returns an instance of)
// The checks are done in the order they are listed above
// The 'error' variable is coerced into an Error object
// if error.response.data exists it will be used and error.message will be ignored
const triggerErrorNotification = (error, managerId) => {
  let errorObj = error
  let message = null
  // Convert to real Error object (attach existing props to errorObj.data)
  const isMessage = (typeof error !== 'object')
  const isNativeError = (error instanceof Error)
  const isCustomObject = (!isMessage && !isNativeError)
  if (isMessage) {
    errorObj = new Error(error.toString())
  }
  if (isCustomObject) {
    errorObj = Object.assign(new Error(error.message), { data: error })
  }
  // Get Error Message from correct property (Axios/HTTP response.data when available)
  const isHttpError = (errorObj.response && errorObj.response.data)
  const isHttpServerError = (errorObj.response && errorObj.response.status >= 500)
  const hasHttpErrorMessage = (isHttpError && typeof errorObj.response.data === 'string' && errorObj.response.data.length > 0)
  const hasErrorMessage = (errorObj.message && errorObj.message.length > 0)
  if (isHttpServerError) {
    message = Vue.i18n.translate('generic server error')
  } else if (hasHttpErrorMessage) {
    message = errorObj.response.data
  } else if (hasErrorMessage) {
    message = errorObj.message
  }
  // Construct Payload (allowing 'message' to fallback to translatable generic server error)
  const payload = { method: 'error', managerId: managerId, params: [ { message: message || Vue.i18n.translate('generic server error') } ] }
  window.parent.postMessage(JSON.stringify(payload), '*')
}

export default {
  triggerCloseNotification,
  triggerErrorNotification
}
